// Firebase Configuration
// Automatically switches between dev and prod based on environment

const firebaseConfigs = {
  development: {
    apiKey: "AIzaSyBP_w7QHbDLvVrGoLOlxlhTEmfoNKQ16co",
    authDomain: "portfoliorebalancer-dev.firebaseapp.com",
    projectId: "portfoliorebalancer-dev",
    storageBucket: "portfoliorebalancer-dev.firebasestorage.app",
    messagingSenderId: "308942531782",
    appId: "1:308942531782:web:bbd70072d3aa447e517bc7",
    measurementId: "G-FWRDL7E9ME"
  },
  production: {
    apiKey: "AIzaSyD683IPNi-OgPi5fYTPY_WAIyZmHr3rafU",
    authDomain: "portfoliorebalancer-prod.firebaseapp.com",
    projectId: "portfoliorebalancer-prod",
    storageBucket: "portfoliorebalancer-prod.firebasestorage.app",
    messagingSenderId: "465646329114",
    appId: "1:465646329114:web:2a4a9ebf7af0540eef60a3",
    measurementId: "G-S24XBD97XZ"
  }
};

// Determine which environment we're in
// In React: process.env.NODE_ENV will be 'development' or 'production'
// You can also use custom env vars like REACT_APP_ENVIRONMENT
const environment = process.env.NODE_ENV || 'development';

// Export the appropriate config
export const firebaseConfig = firebaseConfigs[environment];

// Export environment for debugging
export const currentEnvironment = environment;

console.log(`🔥 Firebase initialized in ${environment} mode`);
